import { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { auth, db } from "../firebase";
import { AuthContext } from "../context/AuthContext";
import {
  clearDeviceSessionId,
  getOrCreateDeviceSessionId,
} from "../services/deviceSession";
import { clearNativeCallSessionForLogout } from "../plugins/NativeLivoraCall";
import { clearAllNativeCallPreparation } from "../calls/nativeCallPreparation";

export default function SingleSessionGate() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const kickingRef = useRef(false);

  useEffect(() => {
    if (!user?.uid) return;

    let cancelled = false;
    let unsub = null;
    const localSessionId = getOrCreateDeviceSessionId();

    const kickForRemoteSession = async () => {
      if (kickingRef.current || cancelled) return;
      kickingRef.current = true;

      clearDeviceSessionId();

      try {
        clearAllNativeCallPreparation();
        await clearNativeCallSessionForLogout();
      } catch (err) {
        console.warn("clearNativeCallSessionForLogout failed:", err?.message || err);
      }

      try {
        await signOut(auth);
      } catch (err) {
        console.warn("SingleSessionGate signOut failed:", err?.message || err);
      }

      navigate("/", { replace: true });
      alert("تم تسجيل الدخول من جهاز آخر.");
    };

    const start = async () => {
      try {
        const functions = getFunctions(undefined, "us-central1");
        const claimActiveSession = httpsCallable(functions, "claimActiveSession");
        await claimActiveSession({ sessionId: localSessionId });
      } catch (err) {
        console.warn("claimActiveSession failed:", err?.message || err);
      }

      if (cancelled) return;

      unsub = onSnapshot(doc(db, "users", user.uid), (snap) => {
        if (!snap.exists()) return;

        const remoteSessionId = String(snap.data()?.activeSessionId || "").trim();
        if (!remoteSessionId || remoteSessionId === localSessionId) return;

        void kickForRemoteSession();
      });
    };

    void start();

    return () => {
      cancelled = true;
      if (unsub) unsub();
    };
  }, [user?.uid, navigate]);

  return null;
}
